/* istanbul ignore file */
import { useCallback, useState } from 'react';

import useEventCallback from '@zenbusiness/application-commons-hooks/useEventCallback';
import { useLocation } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import getPageSection from '#client/utils/getPageSection';

import Logo from './components/Logo';
import { MenuItem } from './components/MenuItem';

import { useDrawerState } from '../hooks/useDrawerState';
import { useBusinessEntityNav } from './hooks/useBusinessEntityNav';
import { StyleBranding, StyledMenu, StyledNav } from './styles';

function BusinessEntityNav() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { toggleDrawer } = useDrawerState();
  const { pathname } = useLocation();

  const [activeItem, setActiveItem] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const { loading, menu } = useBusinessEntityNav({ isMobile });
  const closeMenu = useEventCallback(() => setExpanded(false));
  const openMenu = useEventCallback(() => setExpanded(true));

  const baseEventProps = {
    elementName: 'entity_nav_item',
    pageCategory: 'dashboard',
    pageSection: getPageSection(pathname)
  };

  const handleItemClick = useCallback((index) => {
    setActiveItem(index === activeItem ? null : index);
  }, [setActiveItem, activeItem]);

  const handleMobileItemClick = useCallback(() => {
    if (isMobile) {
      toggleDrawer();
      setActiveItem(null);
    }
  }, [isMobile, toggleDrawer, setActiveItem]);

  if (loading) {
    return null;
  }

  return (
    <StyledNav
      component="nav"
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
      onFocus={openMenu}
    >
      <StyleBranding>
        <Logo />
      </StyleBranding>

      <StyledMenu>
        {menu.map((menuItem, index) => {
          const maybeExpand = activeItem === index;
          const isExpanded = expanded && maybeExpand;

          return (
            <MenuItem
              eventProps={{
                ...baseEventProps,
                ...menuItem.eventProps,
                elementText: menuItem.title,
                navCategory: menuItem.title,
                navIndex: index + 1,
                navLevel: 1
              }}
              expanded={isExpanded}
              key={menuItem.title}
              onClick={() => handleItemClick(index)}
              onMobileClick={handleMobileItemClick}
              {...menuItem}
            />
          );
        })}
      </StyledMenu>
    </StyledNav>
  );
}

export default BusinessEntityNav;
